<div class="summary">
  <figure aria-hidden="true" class="avatar">
    <img [src]="member.profilePicture.path" alt="">
  </figure>
  <div class="summary-content">
    <h3 class="heading">{{ member.firstName }}
      @if (member.hasPrivilegedData) {
        {{ member.lastName }}
      }
    </h3>
    @if (member.lastSeenOn) {
      <div class="last-online">
        <span class="last-online__dot" [class.last-online__dot--active]="isOnlineToday"></span>
        {{ member.lastSeenOn | relativeTime }}
      </div>
    }
    <p>
      <strong>{{ offer.assistanceServices | stringifySelectionTags }}</strong><br>
      @if (offer.workPerimeter) {
        <span>{{ offer.workPerimeter.zip }} {{ offer.workPerimeter.place }}, </span>
      }
      @if (match.distanceKm) {
        <span i18n="@@marketplace.hitlistItem.distance">{{ match.distanceKm }}
                km entfernt</span>
      }
      @if (match.distanceKm === 0) {
        <span
        i18n="@@marketplace.hitlistItem.distanceFewKmAway">wenige km entfernt</span>
      }
    </p>

    @if (member.aboutMe) {
      <p class="description">
        {{ member.aboutMe }}
      </p>
    }
    @if (offer.description) {
      <p class="description">
        {{ offer.description }}
      </p>
    }
    <ul class="summary__member-documents">
      @for (document of member.documents; track document) {
        <li class="summary__member-document">
          <span aria-hidden="true" class="icon icon-file-text"></span>
          <span>{{ document.name }}</span>
        </li>
      }
    </ul>
  </div>
</div>
